import { render, staticRenderFns } from "./TextWrapper.vue?vue&type=template&id=6f3e922e&scoped=true"
import script from "./TextWrapper.vue?vue&type=script&lang=js"
export * from "./TextWrapper.vue?vue&type=script&lang=js"
import style0 from "./TextWrapper.vue?vue&type=style&index=0&id=6f3e922e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_prettier@1.19.1_vue-template-compiler@2.7.16_webpack@5.97.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3e922e",
  null
  
)

export default component.exports